import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getNewsDetails} from '../../actions';
import NewsDetailsPlaceholder from './NewsDetailsPlaceholder';
import NewsDetails from './NewsDetails';
import {withLocalize} from "react-localize-redux";

class NewsDetailsContainer extends Component {
    fetchContent() {
        let slug = this.props.match.params.slug;

        this.props.getNewsDetails(slug);
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        const {news, loading, errors} = this.props;

        if (prevProps.languages !== this.props.languages) {
            this.fetchContent();
        }

        if (prevProps.errors !== errors && !loading) {
            console.log(errors);

            if (errors.status === 303) {
                let uri = this.props.translate('routes.news_details').replace(':slug', errors.redirect);

                this.props.history.push(uri);
            }
        }

        if (!loading && news === {} && errors.status === 422) {
            setTimeout(() => {
                this.props.history.push('/404');
            }, 2000);
        }
    }

    render() {
        const {news, loading} = this.props;

        if (news === {} || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'news-details'
                        }}
                    >
                        <title>{process.env.REACT_APP_SITE_TITLE}</title>
                    </Helmet>
                    <div className="container">
                        <NewsDetailsPlaceholder/>
                    </div>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'news-details'
                    }}
                >
                    <title>{(news.seo_title !== '' ? news.seo_title : news.title) + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE}</title>
                    {news.seo_meta_description !== '' &&
                        <meta name="description" content={news.seo_meta_description} />
                    }
                    {news.seo_facebook_og_title !== '' &&
                        <meta property="og:title" content={news.seo_facebook_og_title} />
                    }
                    {news.seo_facebook_og_description !== '' &&
                        <meta property="og:description" content={news.seo_facebook_og_description} />
                    }
                    {news.seo_facebook_og_image !== '' &&
                        <meta property="og:image" content={news.seo_facebook_og_image} />
                    }
                </Helmet>
                <div className="container">
                    <NewsDetails news={news}/>
                </div>
            </Fragment>
        );
    }
}

NewsDetailsContainer.propTypes = {
    getNewsDetails: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    news: state.news.newsDetails,
    loading: state.news.newsDetailsLoading,
    errors: state.news.newsDetailsErrors,
    languages: state.localize.languages,
});

export default withRouter(connect(mapStateToProps, {getNewsDetails})(withLocalize(NewsDetailsContainer)));



// WEBPACK FOOTER //
// ./src/features/News/components/Details/NewsDetailsContainer.js